module.exports = __webpack_public_path__ + "public/img/banner-swiper.b6d5eb42.png";